import { NextRouter } from "next/router";
import { FieldParams, TypeFieldParams } from "./constants/props";
import { BrandNewVehicle } from "./editable/inventory/vehicles/details-1/variants/brand-new/01/props";

export type Options = {
  code?: string;
  name?: string;
};

export type ImageLinks = {
  mobileLink: string; //800x600
  webLink: string; //1440x1080
};

export type FiltrQueryParams = {
  router: NextRouter;
  page?: string | string[] | undefined | null;
  pagination?: string | string[] | undefined;
  category?: string | string[] | undefined;
  make?: string | string[] | undefined;
  model?: string | string[] | undefined;
  minPrice?: string | string[] | undefined;
  maxPrice?: string | string[] | undefined;
  sort?: string | string[] | undefined;
  search?: string | string[] | undefined;
  minKm?: string | string[] | undefined;
  maxKm?: string | string[] | undefined;
  [key: string]: any;
};
interface StylesProps {
  classes: string[];
  type: TypeFieldParams.Styles;
  value: string | null;
}

export interface ComponentsBaseProps {
  id: string;
  key?: string;
  position: number;
  variants: FieldParams;
  currentVariant: string;
  lastPosition?: number;
  componentName: string;
  isSortable: boolean;
  isDeletable: boolean;
  isEditable: boolean;
  isSmartComponent: boolean;
  smartFeatureName?: string;
  variation?: any;
  label: string;
  advancedConfig?: boolean;
  styles?: StylesProps;
}

export interface Vehicle {
  PK?: string;
  SK?: string;
  feature?: string;
  externalId?: string;
  id: string;
  type: string;
  plate: string;
  fipeCode: string;
  modelYear: number;
  make: string;
  model: string;
  version: string;
  color: string;
  fuel: string;
  transmission: string;
  doors: number;
  kilometers: number;
  isArmored: boolean;
  features: string;
  shortDescription: string;
  images: string;
  price: number;
  generalDescription: string;
  hasExtraKey: boolean;
  hasManual: boolean;
  category: string;
  manufactureYear: number;
  numberGears?: string | null;
  tarja?: string | null;
  typeBrake?: string | null;
  typeCooling?: string | null;
  typeEngine?: string | null;
  typeStart?: string | null;
  powerType?: string | null;
  style?: string | null;
  inventoryId: string | null;
  minPrice?: number;
  maxPrice?: number;
  vehicleZeroKMOutput?: BrandNewVehicle | null;
  allVersions?: Vehicle[];
  manufacturerDescription?: string | null;
}

export type HeadlessContentType<T = any> = Vehicle & {
  fields: T;
};

export enum SellerTypeEnum {
  HYBRID = "Hybrid",
  ONLY_ZERO_KM = "OnlyZeroKM",
  ONLY_USED = "OnlyUsed",
}

export enum BuyerPreferenceEnum {
  ONLY_ZERO_KM = "OnlyZeroKM",
  ONLY_USED = "OnlyUsed",
}
